import { Dispatch, GetState } from "common/types";

import { isSignedIn } from "seneca-common/features/user/state";
import { awaitCondition } from "seneca-common/utils/state/await-condition";

import {
  allStatsHaveFetchedForCourseIfNeeded,
  allStatsNeedFetchingForCourse
} from "../selectors/meta";
import {
  allCourseStatsFetchFinished,
  allCourseStatsNeedsFetching,
  courseStatFetchFinished,
  courseStatNeedsFetching,
  userStatsFetchFinished,
  userStatsNeedsFetching
} from "../state";
import {
  fetchAllCourseStudyStats,
  fetchContentStudyStats,
  fetchCourseStudyStats,
  fetchSectionStudyStats,
  fetchUserStudyStats
} from "./clientActions";

export function fetchUserStudyStatsIfNotFetched() {
  return async function (dispatch: Dispatch, getState: GetState) {
    const state = getState();

    if (isSignedIn(state) && userStatsNeedsFetching(state)) {
      return dispatch(fetchUserStudyStats());
    } else {
      return dispatch(awaitCondition(userStatsFetchFinished));
    }
  };
}

export function fetchAllStatsForCourse(courseId: string) {
  return async function (dispatch: Dispatch, getState: GetState) {
    const contentsFetch = dispatch(fetchContentStudyStats(courseId));
    const sectionsFetch = dispatch(fetchSectionStudyStats(courseId));
    const courseFetch = dispatch(fetchCourseStudyStats(courseId));
    const contentsStats = await contentsFetch;
    const sectionsStats = await sectionsFetch;
    const courseStats = await courseFetch;
    return {
      course: courseStats,
      sections: sectionsStats,
      contents: contentsStats
    };
  };
}

export function fetchAllStatsForCourseIfNotFetched(courseId: string) {
  return async function (dispatch: Dispatch, getState: GetState) {
    if (allStatsNeedFetchingForCourse(getState(), courseId)) {
      return dispatch(fetchAllStatsForCourse(courseId));
    } else {
      return dispatch(
        awaitCondition((state: any) =>
          allStatsHaveFetchedForCourseIfNeeded(state, courseId)
        )
      );
    }
  };
}

export function fetchCourseStudyStatsIfNotFetched(courseId: string) {
  return async function (dispatch: Dispatch, getState: GetState) {
    const state = getState();

    if (courseStatNeedsFetching(state, courseId)) {
      dispatch(fetchCourseStudyStats(courseId));
    } else {
      return dispatch(
        awaitCondition((state: any) => courseStatFetchFinished(state, courseId))
      );
    }
  };
}

export function fetchAllCourseStudyStatsIfNotFetched() {
  return async function (dispatch: Dispatch, getState: GetState) {
    const state = getState();

    if (isSignedIn(state) && allCourseStatsNeedsFetching(state)) {
      return dispatch(fetchAllCourseStudyStats());
    } else {
      return dispatch(awaitCondition(allCourseStatsFetchFinished));
    }
  };
}
